import { useState, useEffect } from 'react'
import { useStatusOverlay } from '@fs/zion-ui'

export default function useErrorOverlay({ error, options, debounce }) {
  const [isDelayed, setIsDelayed] = useState(false)
  const showStatusOverlay = useStatusOverlay()
  useEffect(() => {
    if (error && !isDelayed) {
      showStatusOverlay(options)
      if (debounce) setIsDelayed(true)
    }
  }, [debounce, error, isDelayed, options, showStatusOverlay])

  useEffect(() => {
    if (isDelayed) setTimeout(() => setIsDelayed(false), debounce)
  }, [debounce, isDelayed])
}
